// Правила строк матрицы закупки («Формирование закупки»).
// Группы совпадают с бэкендом: app/business/purchasing/planning/calculator.py::planning_group_rank
// и сортировкой list_purchase_planning_items (свой склад → фулфилмент → остальные).

const num = (value) => {
    const number = Number(value);
    return Number.isFinite(number) ? number : 0;
};

export const PLANNING_GROUPS = [
    { key: "own", title: "🏠 Свой склад", className: "grp own" },
    { key: "fulfillment", title: "🏬 Фулфилмент", className: "grp fill" },
    { key: "rest", title: "📈 Топ продаж — закупка", className: "grp" },
];

export const planningGroupOf = (item) => {
    if (num(item?.own_warehouse_stock_qty) > 0) return "own";
    if (num(item?.fulfillment_stock_qty) > 0) return "fulfillment";
    return "rest";
};

export const groupPlanningItems = (items) => {
    const groups = { own: [], fulfillment: [], rest: [] };
    (items || []).forEach((item) => groups[planningGroupOf(item)].push(item));
    return groups;
};

// Закупка дороже себестоимости рынка (средняя розница топа без наценки рынка).
export const isExpensive = (item) => {
    const purchase = num(item?.selected_purchase_price_uah);
    const marketCost = num(item?.top_sales_normalized_cost_uah);
    return purchase > 0 && marketCost > 0 && purchase > marketCost;
};

// Заказать нельзя: у выбранного поставщика нет остатка.
export const isUnorderable = (item) => num(item?.selected_supplier_stock_qty) <= 0;

// Сравнение цены поставщика с прошлой закупкой на свой склад: "up" | "down" | null.
export const priceVsLastReceipt = (item) => {
    const purchase = num(item?.selected_purchase_price_uah);
    const last = num(item?.own_warehouse_last_cost_uah);
    if (purchase <= 0 || last <= 0 || purchase === last) return null;
    return purchase > last ? "up" : "down";
};

// Запас в днях: свой склад + фулфилмент + заказ, делённые на продажи в день.
export const coverageDays = (item, orderQty) => {
    const daily = num(item?.daily_sales);
    if (daily <= 0) return null;
    const stock = num(item?.own_warehouse_stock_qty) + num(item?.fulfillment_stock_qty) + Math.max(num(orderQty), 0);
    return stock / daily;
};

// Дней в периоде загрузки топа (включительно); null, если дат нет.
export const uploadPeriodDays = (upload) => {
    if (!upload?.date_from || !upload?.date_to) return null;
    const from = Date.parse(`${upload.date_from}T00:00:00Z`);
    const to = Date.parse(`${upload.date_to}T00:00:00Z`);
    if (!Number.isFinite(from) || !Number.isFinite(to) || to < from) return null;
    return Math.round((to - from) / 86400000) + 1;
};
